import { Component, Input } from '@angular/core';
import { AvatarSize, IconName } from '@yupma/ui-kit';
import { UserDocument } from 'server-model';

@Component({
  selector: 'app-user-avatar',
  templateUrl: './user-avatar.component.html',
  styleUrl: './user-avatar.component.scss'
})
export class UserAvatarComponent {
  @Input() size: AvatarSize = AvatarSize.BASE;
  @Input() user: UserDocument|null = null;
}
